import { useContext } from 'react'
import { State } from '../utils/context'
import Select, { matchText } from '../components/select'
import Form from '../components/form'
import { BIBLE_CODES, bookNames } from '../utils/bibles'
import { useViewport } from '../utils/hooks'
import { findBook, findBooks } from '../utils/books'
import styles from './controls.module.css'

// Księgi pasują po początku słowa w nazwie, siglach i nazwach z drugiego języka, np. „Mt”, „Kor”, „Gen”.
const matchBook = (query, id, option) => (
  matchText(query, id, option) || findBooks(query).includes(+id)
)

const bestBook = query => findBook(query, {prefix: true})

const matchChapter = (query, id) => id.startsWith(query.trim())

const bestChapter = query => query.trim()

const Controls = () => {
  const [{input, chapters, active}] = useContext(State)
  const options = Object.fromEntries([...Array(chapters).keys()].map(id => [id+1, id+1]))

  // Otwarty select blokuje przewijanie strony, a w wyszukiwarce przewinięcie wyników chowa klawiaturę.
  const select = !active.search && Object.values(active.control).includes(true)

  useViewport(select || active.search && active.input, select)

  return (
    <div className={styles.controls}>
      <Select name="bible" options={BIBLE_CODES} label="Select Bible" />
      <Select name="book" options={bookNames(input.bible)} match={matchBook} best={bestBook} label="Select Book" />
      <Select name="chapter" options={options} match={matchChapter} best={bestChapter} inputMode="numeric" label="Select Chapter" />
      <Form name="search" label="Search" />
    </div>
  )
}

export default Controls
